//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.NullableStringAdapter
import com.apollographql.apollo.api.Optional
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.present
import com.wintermar.inspection.graphql.LoginMutation
import kotlin.Boolean
import kotlin.Suppress

public object LoginMutation_VariablesAdapter {
  @Suppress(
    "UNUSED_PARAMETER",
    "UNUSED_VARIABLE",
  )
  public fun serializeVariables(
    writer: JsonWriter,
    `value`: LoginMutation,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    if (value.email is Optional.Present) {
      writer.name("email")
      NullableStringAdapter.present().toJson(writer, customScalarAdapters, value.email)
    }
    writer.name("password")
    StringAdapter.toJson(writer, customScalarAdapters, value.password)
  }
}
